import getApiClient from "../../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../../notifications/ducks/actions";
import { connection, setCurrentFilmId } from "../../../../middleware/schedulingSignalRMiddleware";
import { HubConnectionState } from "@microsoft/signalr";

const url = "/film";

export const IMPORT_MOVIE_MAGIC = "IMPORT_MOVIE_MAGIC";
export const CLEAR_REDIRECT_IMPORT_MOVIE_MAGIC = "CLEAR_REDIRECT_IMPORT_MOVIE_MAGIC";
export const SHOOTING_DAYS_TOGGLE_SELECTION = "SHOOTING_DAYS_TOGGLE_SELECTION";
export const SHOOTING_DAYS_TOGGLE_SELECTION_IN_GROUP = "SHOOTING_DAYS_TOGGLE_SELECTION_IN_GROUP";
export const SHOOTING_DAYS_MULTI_SELECT_TO = "SHOOTING_DAYS_MULTI_SELECT_TO";
export const SHOOTING_DAYS_SET_DRAGGING_SCENE_ID = "SHOOTING_DAYS_SET_DRAGGING_SCENE_ID";
export const SHOOTING_DAYS_UNSELECT_ALL = "SHOOTING_DAYS_UNSELECT_ALL";
export const SHOOTING_DAYS_UPDATE_TRUNCATE_SUMMARIES = "SHOOTING_DAYS_UPDATE_TRUNCATE_SUMMARIES";
export const SHOOTING_DAYS_UPDATE_COLOR_CODE_SCENES = "SHOOTING_DAYS_UPDATE_COLOR_CODE_SCENES";
export const SHOOTING_DAYS_CALCULATE_PAGE_LENGTHS = "SHOOTING_DAYS_CALCULATE_PAGE_LENGTHS";
export const CREATE_SCHEDULE = "CREATE_SCHEDULE";
export const FETCH_SCHEDULING_CONSTRAINTS = "FETCH_SCHEDULING_CONSTRAINTS";
export const SET_IS_ADVANCED_SCHEDULING_OPEN = "SET_IS_ADVANCED_SCHEDULING_OPEN";

export function fetchScenesShootingOrder(filmId) {
  return (dispatch) => {
    dispatch({
      type: "FETCH_SCENES_SHOOTING_ORDER",
      payload: getApiClient().get(`/film/${filmId}/scene/shootingOrder`)
    });
  };
}

export function calculatePageLengths(filmId) {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_CALCULATE_PAGE_LENGTHS,
      payload: getApiClient().put(`/film/${filmId}/script/CalculatePageLengths`)
    });
  };
}

export function smartShootingOrder(filmId) {
  return (dispatch) => {
    dispatch({
      type: "FETCH_SCENES_SMART_SHOOTING_ORDER",
      payload: getApiClient().get(`/film/${filmId}/scene/smartShootingOrder`)
    });
  };
}

export function fetchSchedulingConstraints(filmId) {
  return (dispatch) => {
    // Store filmId for SignalR callbacks
    setCurrentFilmId(filmId);

    // Start SignalR connection and subscribe if not connected
    if (connection.state !== HubConnectionState.Connected) {
      connection.start().then(() => connection.invoke('SubscribeToFilm', filmId));
    } else {
      connection.invoke('SubscribeToFilm', filmId);
    }

    dispatch({
      type: FETCH_SCHEDULING_CONSTRAINTS,
      payload: getApiClient().get(`/film/${filmId}/scheduling/constraints`)
    });
  };
}

export function createSchedule(filmId, constraints) {
  // Store filmId for SignalR callbacks
  setCurrentFilmId(filmId);

  if (connection.state !== HubConnectionState.Connected) {
    connection.start().then(() => connection.invoke('SubscribeToFilm', filmId));
  } else {
    connection.invoke('SubscribeToFilm', filmId);
  }


  return (dispatch) => {
    dispatch({
      type: CREATE_SCHEDULE,
      payload: getApiClient().post(`/film/${filmId}/scheduling/create`, constraints)
    })
      .catch((response) => {
        dispatch(showError(`Error creating schedule`));
        dispatch(clearNotifications());
      });
  };
}

export function deleteAllShootingDays(filmId) {
  return (dispatch) => {
    dispatch({
      type: "DELETE_ALL_SHOOTING_DAYS",
      payload: getApiClient().delete(`/film/${filmId}/shootingDay/deleteAll`)
    }).then((response) => {
      dispatch(showInfo(`Deleted all shooting days`));
    })
      .catch((response) => {
        dispatch(showError(`Error deleteing all shooting days`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function resetSceneShootDays(filmId) {
  return (dispatch) => {
    dispatch({
      type: "RESET_SCENE_SHOOTS_DAYS",
      payload: getApiClient().put(`/film/${filmId}/scene/resetSceneShootDays`)
    }).then((response) => {
      dispatch(showInfo(`Reset all shoot days`));
    })
      .catch((response) => {
        dispatch(showError(`Error reseting all shoot days`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function fetchScenesShootingOrderByDay(filmId) {
  return (dispatch) => {
    dispatch({
      type: "FETCH_SCENES_SHOOTING_ORDER_BY_DAY",
      payload: getApiClient().get(`/film/${filmId}/scene/shootingOrderByDay`)
    });
  };
}

export function smartScenesShootingOrderByDay(filmId) {
  return (dispatch) => {
    dispatch({
      type: "FETCH_SCENES_SHOOTING_ORDER_BY_DAY",
      payload: getApiClient().get(
        `/film/${filmId}/scene/smartShootingOrderByDay`
      )
    });
  };
}

export function updateScenesShootingOrder(filmId, scenes) {
  const command = { scenes };
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCENES_SHOOTING_ORDER",
      payload: getApiClient().put(
        `/film/${filmId}/scene/shootingOrder`,
        command
      ),
      meta: { scenes }
    })
      .then((response) => {
        dispatch(showInfo(`Updated scene orders`));
      })
      .catch((response) => {
        dispatch(showError(`Error updating scene orders`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function importMovieMagic(filmId, formData) {
  return (dispatch) => {
    dispatch({
      type: IMPORT_MOVIE_MAGIC,
      payload: getApiClient().post(`film/${filmId}/ShootingDay/ImportFromMovieMagic`, formData, {
        headers: {
          "content-type": `multipart/form-data`
        }
      })
    }).then((response) => {
      dispatch(showInfo(`Successfully imported Movie Magic Schedule`));
    })
      .catch((response) => {
        dispatch(showError(`Error importing Movie Magic Schedule`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function addScenesShootingOrderDays(filmId, days) {
  const command = { days };
  return (dispatch) => {
    dispatch({
      type: "ADD_SCENES_SHOOTING_ORDER_DAYS",
      payload: getApiClient().post(
        `/film/${filmId}/scene/shootingOrderByDay`,
        command
      ),
      meta: { days }
    })
      .then((response) => {
        dispatch(showInfo(`Updated scene orders`));
      })
      .catch((response) => {
        dispatch(showError(`Error updating scene orders`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function updateTruncateSummaries(filmId, shootingDaySettingsId, truncateSummaries) {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_UPDATE_TRUNCATE_SUMMARIES,
      payload: getApiClient().put(
        `/film/${filmId}/ShootingDay/${shootingDaySettingsId}/TruncateSummaries`,
        { truncateSummaries }
      ),
      meta: { truncateSummaries }
    })
      .then((response) => {
        //dispatch(showInfo(`Updated Shooting Day actor order`));
      })
      .catch((response) => {
        dispatch(showError(`Error updating Shooting Day truncate summaries`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function updateColorCodeScenes(filmId, shootingDaySettingsId, colorCodeScenes) {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_UPDATE_COLOR_CODE_SCENES,
      payload: getApiClient().put(
        `/film/${filmId}/ShootingDay/${shootingDaySettingsId}/ColorCodeScenes`,
        { colorCodeScenes }
      ),
      meta: { colorCodeScenes }
    })
      .then((response) => {
        //dispatch(showInfo(`Updated Shooting Day actor order`));
      })
      .catch((response) => {
        dispatch(showError(`Error updating Shooting Day color code scenes`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function updateOrder(startIndex, endIndex) {
  return (dispatch) => {
    dispatch({
      type: "REORDER_SCENES_SHOOTING_ORDER",
      meta: { startIndex, endIndex }
    });
  };
}

export function updateSceneOrder(
  startIndex,
  endIndex,
  sourceDay,
  destinationDay
) {
  return (dispatch) => {
    dispatch({
      type: "REORDER_SCENES_SHOOTING_ORDER_DAY_SCENES",
      meta: { startIndex, endIndex, sourceDay, destinationDay }
    });
  };
}

export function updateDayOrder(startIndex, endIndex) {
  return (dispatch) => {
    dispatch({
      type: "REORDER_SCENES_SHOOTING_ORDER_DAYS",
      meta: { startIndex, endIndex }
    });
  };
}

export function addShootingDay() {
  return (dispatch) => {
    dispatch({
      type: "ADD_SCENES_SHOOTING_ORDER_DAY"
    });
  };
}

export function deleteShootingDay(dayNumber) {
  return (dispatch) => {
    dispatch({
      type: "DELETE_SCENES_SHOOTING_ORDER_DAY",
      meta: { dayNumber }
    });
  };
}

export function clearRedirect(dispatch) {
  return (dispatch) => {
    dispatch({
      type: CLEAR_REDIRECT_IMPORT_MOVIE_MAGIC
    });
  };
}

export function downloadShootingDays(id) {
  return (dispatch) => {
    dispatch({
      type: "DOWNLOAD_SHOOTING_DAYS",
      payload: getApiClient().post(`${url}/${id}/shootingDay/download`, {}),
    });
  };
}

export function clearPdf() {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_SHOOTING_DAYS_PDF",
      meta: {},
    });
  };
}

export function clearDownload() {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_SHOOTING_DAYS_DOWNLOAD",
      meta: {},
    });
  };
}

export function toggleSelection(sceneId) {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_TOGGLE_SELECTION,
      meta: { sceneId }
    });
  };
}

export function toggleSelectionInGroup(sceneId) {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_TOGGLE_SELECTION_IN_GROUP,
      meta: { sceneId }
    });
  };
}

export function multiSelectTo(sceneId) {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_MULTI_SELECT_TO,
      meta: { sceneId }
    });
  };
}

export function setDraggingSceneId(sceneId) {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_SET_DRAGGING_SCENE_ID,
      meta: { sceneId }
    });
  };
}

export function unselectAll() {
  return (dispatch) => {
    dispatch({
      type: SHOOTING_DAYS_UNSELECT_ALL
    });
  };
}

export const setIsAdvancedSchedulingOpen = (isOpen: boolean) => {
  return (dispatch) => {
    dispatch({
      type: SET_IS_ADVANCED_SCHEDULING_OPEN,
      meta: { isOpen }
    });
  };
}

